function MusterError(message, {
    code,
    path,
    args,
    route,
    method,
    results,
    errors,
    stack,
  }) {
    this.name = 'MusterError';
    this.message = message;
    this.code =  "";
    this.path = "";
    this.args =  "";
    this.route =  "";
    this.method =  "";
    this.results =  "";
    this.errors =  "";
    this.stack = "";
  
  
  
    
  }
  
  MusterError.prototype = Object.create(Error.prototype);
  MusterError.prototype.constructor = MusterError;
  
  MusterError.HANDLER_ERROR = 'MusterError::HANDLER_ERROR';
  
  module.exports = MusterError;